var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.679688 13.035156 L 16.851562 13.035156 L 16.851562 16.289062 L 15.679688 16.289062 Z M 15.679688 13.035156 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.148438 13.035156 L 26.320312 13.035156 L 26.320312 16.289062 L 25.148438 16.289062 Z M 25.148438 13.035156 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.097656 14.792969 L 28.90625 14.792969 L 28.90625 28.859375 L 13.097656 28.859375 Z M 13.097656 14.792969 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.632812 23.28125 L 22.519531 23.28125 L 22.519531 26.132812 L 19.632812 26.132812 Z M 19.632812 23.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.003906 19.773438 L 18.882812 19.773438 L 18.882812 22.628906 L 16.003906 22.628906 Z M 16.003906 19.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.632812 19.773438 L 22.519531 19.773438 L 22.519531 22.628906 L 19.632812 22.628906 Z M 19.632812 19.773438 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.277344 16.285156 C 16.574219 16.285156 16.820312 16.046875 16.820312 15.761719 L 16.820312 13.558594 C 16.820312 13.261719 16.574219 13.03125 16.277344 13.03125 C 15.972656 13.03125 15.734375 13.261719 15.734375 13.558594 L 15.734375 15.753906 C 15.734375 16.046875 15.972656 16.285156 16.277344 16.285156 Z M 16.277344 16.285156 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 25.742188 16.285156 C 26.039062 16.285156 26.285156 16.046875 26.285156 15.761719 L 26.285156 13.558594 C 26.285156 13.261719 26.039062 13.03125 25.742188 13.03125 C 25.441406 13.03125 25.195312 13.261719 25.195312 13.558594 L 25.195312 15.753906 C 25.195312 16.046875 25.441406 16.285156 25.742188 16.285156 Z M 25.742188 16.285156 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.003906 23.28125 L 18.882812 23.28125 L 18.882812 26.132812 L 16.003906 26.132812 Z M 16.003906 23.28125 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.398438 14.851562 L 26.878906 14.851562 L 26.878906 15.753906 C 26.878906 16.363281 26.367188 16.855469 25.742188 16.855469 C 25.113281 16.855469 24.605469 16.363281 24.605469 15.753906 L 24.605469 14.851562 L 17.417969 14.851562 L 17.417969 15.753906 C 17.417969 16.363281 16.902344 16.855469 16.277344 16.855469 C 15.644531 16.855469 15.136719 16.363281 15.136719 15.753906 L 15.136719 14.851562 L 14.613281 14.851562 C 13.792969 14.851562 13.128906 15.496094 13.128906 16.285156 L 13.128906 27.402344 C 13.128906 28.203125 13.792969 28.84375 14.613281 28.84375 L 27.402344 28.84375 C 28.222656 28.84375 28.886719 28.203125 28.886719 27.402344 L 28.886719 16.285156 C 28.886719 15.496094 28.222656 14.851562 27.398438 14.851562 Z M 27.054688 26.59375 C 27.054688 26.878906 26.789062 27.113281 26.460938 27.113281 L 15.554688 27.113281 C 15.226562 27.113281 14.960938 26.878906 14.960938 26.59375 L 14.960938 19.394531 C 14.960938 19.105469 15.226562 18.871094 15.554688 18.871094 L 26.457031 18.871094 C 26.789062 18.871094 27.054688 19.105469 27.054688 19.394531 Z M 27.054688 26.59375 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 23.402344 19.773438 L 26.285156 19.773438 L 26.285156 22.628906 L 23.402344 22.628906 Z M 23.402344 19.773438 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.79d6086e656bcc2c44cfb0b9d0226cf3.svg";
export { ForwardRef as ReactComponent };